<style lang="less">
    .delLayer-dialog {
        width: 386px;
        .delLayer-content {
            padding: 20px;
        }
        .delLayer-select {
            margin-top: 20px;
        }
    }
</style>

<template>
    <Dialog class="delLayer-dialog" :title="$t('title')" :mask="true" @close="closeThis">
        <div class="delLayer-content">
            <Radio-group v-model="delType" @on-change="selectType">
                <Radio label="del">{{ $t("del") }}</Radio>
                <Radio label="move">{{ $t("move") }}</Radio>
            </Radio-group>
            <div class="delLayer-select" v-if="delType == 'move'">
                <i-select v-model="layer" style="width: 200px">
                    <i-option v-for="item in layers" :value="item.id" v-if="!item.back && item.id != activeLayer" :key="item.id">
                        {{ item.name }}
                    </i-option>
                </i-select>
            </div>
        </div>

        <div class="dialog-btnbox-normal" :style="{ direction: !internal ? 'ltr' : 'rtl' }">
            <div class="dialog-btn-ok" @click="confirm()">{{ $t("confirm") }}</div>
            <div class="" @click="closeThis()">{{ $t("cancel") }}</div>
        </div>
    </Dialog>
</template>

<script lang="ts">
    import { Component, Watch, Prop, Vue } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            Dialog,
        },
    })
    export default class DelLayer extends Vue {
        delType = "del";
        layer = "";
        activeLayer = "";
        // 初始数据可以直接声明为实例的属性
        get layers() {
            return this.$store.state.page.activedPageLayers;
        }
        get selectLayerIndex() {
            return this.$store.state.ui.selectLayerIndex;
        }
        set selectLayerIndex(v) {
            this.$store.commit("setStatus", {
                type: "selectLayerIndex",
                data: v,
            });
        }
        closeThis() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }

        selectType(v) {
            if (v == "move") {
                let i = 0;
                for (; i < this.layers.length; i++) {
                    if (i == this.selectLayerIndex) {
                        this.activeLayer = this.layers[i].id;
                    }
                }
                for (let i = 0; i < this.layers.length; i++) {
                    if (!this.layers[i].back && this.layers[i].id != this.activeLayer) {
                        this.layer = this.layers[i].id;
                        break;
                    }
                }
            }
        }

        confirm() {
            window["_view"].deleteLayer(this.selectLayerIndex, this.delType === "move" ? this.layer : undefined);
            if (this.selectLayerIndex > this.layers.length - 1) {
                this.selectLayerIndex = this.layers.length - 1;
            }
            this.closeThis();
        }

        //生命周期
        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "title": "删除图层",
    "confirm": "确认",
    "cancel": "取消",
    "del": "删除形状",
    "move": "将形状转移到其他图层"
  },
  "en": {
    "title": "Delete Layer",
    "confirm": "OK",
    "cancel": "Cancel",
    "del": "Delete Shape",
    "move": "Move shape to other layer"
  },
  "jp": {
    "title": "レイヤーを削除",
    "confirm": "OK",
    "cancel": "キャンセル",
    "del": "図形を削除",
    "move": "図形を他のレイヤーに転送する"
  },
  "de": {
    "title": "Layer löschen ",
    "confirm": "Sichern",
    "cancel": "Abbrechen",
    "del": "Form löschen",
    "move": "Form auf andere Ebene übertragen"
  },
  "fr": {
    "title": "Supprimer Calque",
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "del": "Supprimer la Forme",
    "move": "Déplacer la forme vers un autre calque"
  },
  "es": {
    "title": "Borrar Capa",
    "confirm": "OK",
    "cancel": "Cancelar",
    "del": "Borrar la forma",
    "move": "Mover la forma a otra capa"
  },
  "pt": {
    "title": "Eliminar Camada",
    "confirm": "OK",
    "cancel": "Cancelar",
    "del": "Eliminar Forma",
    "move": "Mover forma para outra camada"
  },
  "it": {
    "title": "Elimina Livello",
    "confirm": "OK",
    "cancel": "Annulla",
    "del": "Elimina Forma",
    "move": "Sposta Forma su un Altro Livello"
  },
  "tw": {
    "title": "刪除圖層",
    "confirm": "確認",
    "cancel": "取消",
    "del": "刪除形狀",
    "move": "將形狀轉移到其他圖層"
  },
  "kr": {
    "title": "레이어 삭제",
    "confirm": "확인",
    "cancel": "취소",
    "del": "도형 삭제",
    "move": "도형을 다른 레이어로 이동"
  }
}
</i18n>
